<template>
    <div style="width:100%;heigh:100%;" id='working'>
        <!--班次管理开始-->
        <el-card class="box-card">
            <div class="title" style="margin-bottom:10px">
                <span class="head-title">班次维护</span>
                <el-button style="margin-left:10px"  @click="addShiftData()" type="primary" size='mini' >新增班次</el-button>    
            </div>
            <el-table :data="shiftList" stripe style="width: 100%;border-radius: 10px;" border height="240">
                <el-table-column prop="shiftCode" label="班次编码"></el-table-column>
                <el-table-column prop="shiftName" label="班次名称"></el-table-column>
                <el-table-column prop="beginTime" label="上班时间"></el-table-column>
                <el-table-column prop="endTime" label="下班时间"></el-table-column>
                <el-table-column prop="workTime" label="工作时长">
                    <template slot-scope="scope">
                        {{scope.row.workTime|parseHours}}
                    </template>
                </el-table-column>
                <el-table-column prop="isDaysSpanned" label="是否跨日">
                    <template slot-scope="scope">
                        {{scope.row.isDaysSpanned?'是':'否'}}
                    </template>
                </el-table-column>
                <el-table-column label="操作" >
                    <template slot-scope="scope">
                        <el-button  @click="showEditDialog(scope.row,scope.$index)" type="text" size="small" >编辑</el-button>
                        <el-button class="btn-del" @click="deleteShiftItem(scope.row.id)" type="text" size="small">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-card>
        <!--班次管理结束-->
        

        <!--年日历开始-->
        <el-card class="box-card" style="margin-top: 16px;">
            <div style="width:100%;display:flex;">
                <span class="head-title">日历维护</span>
                <div style="display: flex;justify-content: center;width:94%;" >
                    <div class="date-picker-warp">
                        <i class="el-icon-my-left time-btn"  @click="changeMonth($event,1)"></i>
                        <el-date-picker v-model="activeMonth" @change="changeMonth($event,2)" class="month-select" :clearable="false" format="yyyy-MM" value-format="yyyy-MM" type="month" placeholder="选择月"></el-date-picker>
                        <i class="el-icon-my-right time-btn"  @click="changeMonth($event,3)"></i>
                    </div>
                </div>
            </div>
            <div style="margin-bottom:10px">
                <span class="title"> 资源：</span>
                <el-select @change="factoryModelChange"  v-model="selectFactoryModelId" :placeholder="`请选择资源`"  style="display:inline-block" filterable>
                    <el-option v-for="item in listResource"  :key="item.id" :value="item.id" :label="item.name"></el-option>
                </el-select>
                <el-button style="margin-left:20px" type="primary" size='mini' @click="itemClick({},1)">批量操作</el-button>
            </div>
            <div style="display:flex;flex-wrap: wrap;" class="calendar-box">
                <div v-for="(item,index) in copyList" :key='index' class="calendar-warp" :style="index==2?{marginRight:'0px'}:{}">
                    <div class="calendar-title">{{item|parseMonth}}月</div>
                    <code style="display:flex" class="warp-heard">
                        <div style="display:flex;"><span class="sub-text">周一</span></div>
                        <div style="display:flex;"><span class="sub-text">周二</span></div>
                        <div style="display:flex;"><span class="sub-text">周三</span></div>
                        <div style="display:flex;"><span class="sub-text">周四</span></div>
                        <div style="display:flex;"><span class="sub-text">周五</span></div>
                        <div style="display:flex;"><span class="sub-text" style="color:red">周六</span></div>
                        <div style="display:flex;border-right:none"><span class="sub-text" style="color:red">周日</span></div>
                    </code>
                    <code v-for="(sub,subIndex) in item" :key='subIndex' style="display:flex" class="warp-body">
                        <div v-for="(lastItem,lastIndex) in sub" :key="lastIndex" style="display:flex;" class="last-item" :style="computedSubStyle(subIndex,lastIndex,lastItem)">
                            <span :class="lastItem.isToDay?['sub-text','today-bg']:['sub-text']" @click="itemClick(lastItem,2)" > 
                                <code class="left-day">{{lastItem|parseDate}}</code> 
                                <code class="right-shift" v-if="lastItem.shiftName">{{lastItem.shiftName}}</code>
                            </span>
                            <img v-if="lastItem.isWorkDay" class="del-day" @click="delDay(lastItem)"  src='../../../static/img/del-hover.png'>
                        </div>
                    </code>
                </div>
            </div>
        </el-card>
        <!--年日历结束-->

        <!--新增班次开始-->
        <el-dialog class="working-dialog" custom-class="working-dialog-wrap" title="新增班次" @close="closeAddDialog" :visible.sync="addDialogVisible" :width="span==5?'46%':'68%'"
            center :close-on-click-modal="false">
            <el-form :model="addShiftForm" :rules="rules" ref="addShiftForm" class="addForm">
                <el-row :gutter="20" :style="W?{marginBottom: '10px'}:{marginBottom: '0px'}">
                    <el-col :span="12" >
                        <div class="">
                            <span class="title">班次编码：</span>
                            <el-form-item class="value" style="display: inline-block;" prop="shiftCode">
                                <el-input maxlength="32"  v-model="addShiftForm.shiftCode" placeholder="班次编码"></el-input>
                            </el-form-item>
                        </div>
                    </el-col>
                    <el-col :span="12" >
                        <div class="">
                            <span class="title">班次名称：</span>
                            <el-form-item class="value" style="display: inline-block;" prop="shiftName">
                                <el-input maxlength="32"  v-model="addShiftForm.shiftName" placeholder="班次名称"></el-input>
                            </el-form-item>
                        </div>
                    </el-col>
                </el-row>
                <el-row :gutter="20" :style="W?{marginBottom: '10px'}:{marginBottom: '0px'}">
                    <el-col :span="12" >
                        <div class="">
                            <span class="title">开始时间：</span>
                            <el-form-item class="value" style="width: 130px; display: inline-block;" prop="beginTime">
                                <el-time-picker style="width: 200px;" @change="dateChange" clearable  v-model="addShiftForm.beginTime" placeholder="开始时间" format="HH:mm" value-format="HH:mm"></el-time-picker>
                            </el-form-item>
                        </div>
                    </el-col>
                    <el-col :span="12" >
                        <div class="">
                            <span class="title">结束时间：</span>
                            <el-form-item class="value" style="width: 130px; display: inline-block;" prop="endTime">
                                <el-time-picker style="width: 200px;" @change="dateChange" clearable v-model="addShiftForm.endTime" placeholder="结束时间" format="HH:mm" value-format="HH:mm"></el-time-picker>
                            </el-form-item>
                        </div>
                    </el-col>
                </el-row>
                <el-row :gutter="20" :style="W?{marginBottom: '10px'}:{marginBottom: '0px'}">
                    <el-col :span="12" >
                        
                        <div class="">
                            <span class="title">是否跨日：</span>
                            <el-form-item class="value" style="width: 130px; display: inline-block;">
                                <el-radio v-model="addShiftForm.isDaysSpanned" :label="true">是</el-radio>
                                <el-radio v-model="addShiftForm.isDaysSpanned" :label="false">否</el-radio>
                            </el-form-item>
                        </div>
                    </el-col>
                </el-row>
                
                <el-row >
                    <div style="position: relative;top: -10px;">
                        <el-button   @click="addItem" type="primary" size='mini' >添加休息时间</el-button>
                    </div>
                    <el-table  :data="addShiftForm.restList" stripe style="width: 100%" border :maxHeight="260">
                        <el-table-column label="序号" :width="50">
                            <template slot-scope="scope">
                                <el-form-item>
                                    {{scope.$index+1}}
                                </el-form-item>
                            </template>
                        </el-table-column>
                        <el-table-column prop="shiftCode" :min-width="120" label="开始时间">
                            <template slot-scope="scope">
                                <el-form-item :prop="`restList[${scope.$index}].beginTime`" :rules="rules.beginTime">
                                    <el-time-picker @change="submitStartTimeChange($event,scope.row)" style="max-width: 190px;" clearable  v-model="scope.row.beginTime" placeholder="开始时间" format="HH:mm" value-format="HH:mm"></el-time-picker>
                                </el-form-item>
                            </template>
                        </el-table-column>
                        <el-table-column prop="shiftCode" :min-width="120" label="结束时间">
                            <template slot-scope="scope">
                                <el-form-item :prop="`restList[${scope.$index}].endTime`" :rules="rules.endTime">
                                    <el-time-picker @change="submitEndTimeChange($event,scope.row)" style="max-width: 190px;"  clearable v-model="scope.row.endTime" placeholder="结束时间" format="HH:mm" value-format="HH:mm"></el-time-picker>
                                </el-form-item>
                            </template>
                        </el-table-column>
                        <el-table-column prop="shiftName" :min-width="40" label="是否跨天">
                            <template slot-scope="scope">
                                <el-form-item>
                                    <el-checkbox  disabled  v-model="scope.row.isDaysSpanned" ></el-checkbox>
                                </el-form-item>
                            </template>
                        </el-table-column>
                        <el-table-column prop="shiftName" label="休息类型" :min-width="100">
                            <template slot-scope="scope">
                                <el-form-item>
                                    <el-input maxlength="32"  v-model="scope.row.restType" placeholder="休息类型"></el-input>
                                </el-form-item>
                            </template>
                        </el-table-column>
                        <el-table-column prop="beginTime" label="操作" :width="80">
                            <template slot-scope="scope">
                                <el-form-item>
                                    <el-button class="btn-del" @click="deleteItem(scope.$index)" type="text" size="small">删除</el-button>
                                </el-form-item>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-row>
             </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="submitAddCalendar">确 定</el-button>
                <el-button @click="closeAddDialog">取 消</el-button>
            </span>
        </el-dialog> 
        <!--新增班次结束-->

        <!--编辑班次开始-->
        <el-dialog class="working-dialog" custom-class="working-dialog-wrap" title="编辑班次" @close="closeEditShiftDialog" :visible.sync="editShiftDialogVisible" :width="span==5?'46%':'68%'"
            center :close-on-click-modal="false">
            <el-form :model="addShiftForm" :rules="rules" ref="editShiftForm" class="addForm">
                <el-row :gutter="20" :style="W?{marginBottom: '10px'}:{marginBottom: '0px'}">
                    <el-col :span="12" >
                        <div class="">
                            <span class="title">班次编码：</span>
                            <el-form-item class="value" style="display: inline-block;" prop="shiftCode">
                                <el-input disabled maxlength="32"  v-model="addShiftForm.shiftCode" placeholder="班次编码"></el-input>
                            </el-form-item>
                        </div>
                    </el-col>
                    <el-col :span="12" >
                        <div class="">
                            <span class="title">班次名称：</span>
                            <el-form-item class="value" style="display: inline-block;" prop="shiftName">
                                <el-input maxlength="32"  v-model="addShiftForm.shiftName" placeholder="班次名称"></el-input>
                            </el-form-item>
                        </div>
                    </el-col>
                </el-row>
                <el-row :gutter="20" :style="W?{marginBottom: '10px'}:{marginBottom: '0px'}">
                    <el-col :span="12" >
                        <div class="">
                            <span class="title">开始时间：</span>
                            <el-form-item class="value" style="width: 130px; display: inline-block;" prop="beginTime">
                                <el-time-picker style="width: 200px;" @change="dateChange" clearable  v-model="addShiftForm.beginTime" placeholder="开始时间" format="HH:mm" value-format="HH:mm"></el-time-picker>
                            </el-form-item>
                        </div>
                    </el-col>
                    <el-col :span="12" >
                        <div class="">
                            <span class="title">结束时间：</span>
                            <el-form-item class="value" style="width: 130px; display: inline-block;" prop="endTime">
                                <el-time-picker style="width: 200px;" @change="dateChange" clearable v-model="addShiftForm.endTime" placeholder="结束时间" format="HH:mm" value-format="HH:mm"></el-time-picker>
                            </el-form-item>
                        </div>
                    </el-col>
                </el-row>
                <el-row :gutter="20" :style="W?{marginBottom: '10px'}:{marginBottom: '0px'}">
                    <el-col :span="12" >
                        
                        <div class="">
                            <span class="title">是否跨日：</span>
                            <el-form-item class="value" style="width: 130px; display: inline-block;">
                                <el-radio v-model="addShiftForm.isDaysSpanned" :label="true">是</el-radio>
                                <el-radio v-model="addShiftForm.isDaysSpanned" :label="false">否</el-radio>
                            </el-form-item>
                        </div>
                    </el-col>
                </el-row>
                <el-row >
                    <div style="position: relative;top: -10px;">
                        <el-button   @click="addItem" type="primary" size='mini' >添加休息时间</el-button>
                    </div>
                    <el-table  :data="addShiftForm.restList" stripe style="width: 100%" border :maxHeight="260">
                        <el-table-column label="序号" :width="50">
                            <template slot-scope="scope">
                                <el-form-item>
                                    {{scope.$index+1}}
                                </el-form-item>
                            </template>
                        </el-table-column>
                        <el-table-column prop="shiftCode" :min-width="120" label="开始时间">
                            <template slot-scope="scope">
                                <el-form-item :prop="`restList[${scope.$index}].beginTime`" :rules="rules.beginTime">
                                    <el-time-picker @change="submitStartTimeChange($event,scope.row)" style="max-width: 190px;" clearable  v-model="scope.row.beginTime" placeholder="开始时间" format="HH:mm" value-format="HH:mm"></el-time-picker>
                                </el-form-item>
                            </template>
                        </el-table-column>
                        <el-table-column prop="shiftCode" :min-width="120" label="结束时间">
                            <template slot-scope="scope">
                                <el-form-item :prop="`restList[${scope.$index}].endTime`" :rules="rules.endTime">
                                    <el-time-picker @change="submitEndTimeChange($event,scope.row)" style="max-width: 190px;"  clearable v-model="scope.row.endTime" placeholder="结束时间" format="HH:mm" value-format="HH:mm"></el-time-picker>
                                </el-form-item>
                            </template>
                        </el-table-column>
                        <el-table-column prop="shiftName" :min-width="40" label="是否跨天">
                            <template slot-scope="scope">
                                <el-form-item>
                                    <el-checkbox disabled  v-model="scope.row.isDaysSpanned" ></el-checkbox>
                                </el-form-item>
                            </template>
                        </el-table-column>
                        <el-table-column prop="shiftName" label="休息类型" :min-width="100">
                            <template slot-scope="scope">
                                <el-form-item>
                                    <el-input maxlength="32"  v-model="scope.row.restType" placeholder="休息类型"></el-input>
                                </el-form-item>
                            </template>
                        </el-table-column>
                        <el-table-column prop="beginTime" label="操作" :width="80">
                            <template slot-scope="scope">
                                <el-form-item>
                                    <el-button class="btn-del" @click="deleteItem(scope.$index)" type="text" size="small">删除</el-button>
                                </el-form-item>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-row>
             </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="submitEditShift">确 定</el-button>
                <el-button @click="closeEditShiftDialog">取 消</el-button>
            </span>
        </el-dialog> 
        <!--编辑班次结束-->

        <!--编辑窗口开始-->
        <el-dialog class="working-dialog" custom-class="working-dialog-wrap" title="编辑节假日" @close="closeEditDialog" :visible.sync="editDialogVisible" :width="span==5?'45%':'68%'"
            center :close-on-click-modal="false">
            <el-form :model="addForm" :rules="rules" ref="changeForm" class="addForm">
                <el-row :gutter="20">
                    <el-col :span="16" :offset="4">
                        <div class="">
                            <span class="title">日期：</span>
                            <el-form-item class="value time-range" style="width:300px">
                                <el-date-picker :disabled="!addForm.isChangeAll" :clearable="false" :picker-options="{disabledDate(time) {return time.getTime() > new Date(addForm.endTime).getTime()},}"
                                    style="width: 130px; display: inline-block;" v-model="addForm.beginTime" type="date"
                                    placeholder="开始日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd"></el-date-picker>
                                <span style="margin:0 8px">至</span>
                                <el-date-picker :disabled="!addForm.isChangeAll" :clearable="false"
                                    style="width: 130px; display: inline-block;" v-model="addForm.endTime" type="date" :picker-options="{disabledDate(time) {return time.getTime() < new Date(addForm.beginTime).getTime()-24*60*60*1000},}"
                                    placeholder="结束日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd"></el-date-picker>
                            </el-form-item>
                        </div>
                    </el-col>
                </el-row>
                <el-row v-if="addForm.isChangeAll">
                    <span>工作日维护</span>
                    <el-checkbox-group v-model="addForm.weekDays" style="display:inline-block;">
                        <el-checkbox :label="1">星期一</el-checkbox>
                        <el-checkbox :label="2">星期二</el-checkbox>
                        <el-checkbox :label="3">星期三</el-checkbox>
                        <el-checkbox :label="4">星期四</el-checkbox>
                        <el-checkbox :label="5">星期五</el-checkbox>
                        <el-checkbox :label="6">星期六</el-checkbox>
                        <el-checkbox :label="7">星期天</el-checkbox>
                    </el-checkbox-group>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="16" :offset="4">
                        <div class="">
                            <span class="title" style="margin-left: -14px;width: 84px;">调整为：</span>
                            <el-form-item class="value" >
                                <el-select  size="small" v-model="addForm.isWorkDay"
                                    style="display:block">
                                    <el-option label="工作日" :value="true"></el-option>
                                    <el-option label="休息日" :value="false"></el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                    </el-col>
                </el-row>

                <el-row :gutter="20" v-if="addForm.isWorkDay">
                    <div >
                        <el-table ref="shifTable" :data="shiftListCopy" stripe style="width: 100%" :maxHeight="300" border>
                            <el-table-column width='30' fixed >
                                <template slot-scope="scope">
                                    <el-radio :label="scope.row.id" v-model="addForm.shiftId" ></el-radio>
                                </template>
                            </el-table-column>
                            <el-table-column prop="shiftCode" label="班次编码"></el-table-column>
                            <el-table-column prop="shiftName" label="班次名称"></el-table-column>
                            <el-table-column prop="beginTime" label="上班时间"></el-table-column>
                            <el-table-column prop="endTime" label="下班时间"></el-table-column>
                            <el-table-column prop="workTime" label="工作时长">
                                <template slot-scope="scope">
                                    {{scope.row.workTime|parseHours}}
                                </template>
                            </el-table-column>
                            <el-table-column prop="isDaysSpanned" label="是否跨日">
                                <template slot-scope="scope">
                                    {{scope.row.isDaysSpanned?'是':'否'}}
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </el-row>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="updateCalendar()">确 定</el-button>
                <el-button @click="closeEditDialog">取 消</el-button>
            </span>
        </el-dialog>
        <!--编辑窗口结束-->
    </div>
</template>

<script>
    export default {
        name: 'WorkingCalendar',
        data() {
            return {
                selectFactoryModelId:null,
                listResource:[],
                editDialogVisible: false,
                selectYear: ''+new Date().getFullYear(),
                addForm: {
                    beginTime: '',
                    endTime: '',
                    isChangeAll:false,
                    isWorkDay: false,
                    shiftId:null,
                    factoryModelId:null,
                    weekDays:[],
                },
                editShiftDialogVisible:false,
                addShiftForm:{
                    beginTime: '',
                    endTime: '',
                    shiftCode:'',
                    shiftName:'',
                    isDaysSpanned: false,
                    restList:[],
                },
                shiftIdList:[],
                activeMonth:'2021-01',
                startMonth:'',
                endMonth:'',
                addDialogVisible:false,
                dataList: [],
                copyList: [],
                startTime: '',
                endTime: '',
                value: new Date(),
                value1: [],
                value2: 2,
                W: false,
                rules: {
                    date: [
                        { required: true, message: '请选择放假时间', trigger: 'blur' }
                    ],
                    time: [
                        { required: true, message: '上下班时间不能为空', trigger: 'blur' }
                    ],
                    beginTime: [
                        { required: true, message: '请选择开始时间', trigger: 'blur' }
                    ],
                    endTime: [
                        { required: true, message: '请选择结束时间', trigger: 'blur' }
                    ],
                    shiftCode: [
                        { required: true, message: '请输入班次编码', trigger: 'blur' }
                    ],
                    shiftName: [
                        { required: true, message: '请输入班次名称', trigger: 'blur' }
                    ],
                },
                addDialogVisible: false,
                shiftList: [],
                shiftListCopy: [],
                permission: JSON.parse(localStorage.getItem("permission")),
                expands: [],
                colors:['#19ccab','#FFBB37','#409EFF','#FE825F']
            }
        },
        mounted: async function () {
            await this.loadListResource()
            if(this.listResource.length>0){
                this.selectFactoryModelId = this.listResource[0].id
            }
            this.activeMonth = commonUtils.timestampToDate(new Date().getTime()).slice(0,7)
            this.changeMonth({},2)
            this.loadShiftConfig()
            let w = document.documentElement.clientWidth || document.body.clientWidth;
            w >= 1900 ? this.W = true : this.W = false
            window.onresize = () => {
                let w = document.documentElement.clientWidth || document.body.clientWidth;
                w >= 1900 ? this.W = true : this.W = false
            }
        },
        computed: {
            span() {
                return this.W ? 5 : 7
            }
        },
        methods: {
            
            prev(activeMonth){
                let [year,month] = activeMonth.split('-')
                if(Number(month)==1){
                    year = Number(year)-1
                    month = 12
                }else{
                    month = Number(month) - 1
                }
                log(year,month)
                return year + '-' + month
            },

            changeMonth(ev,type){
                if(type==1){
                    this.endMonth = this.activeMonth
                    this.activeMonth = this.prev(this.activeMonth)
                    this.startMonth = this.prev(this.activeMonth)
                }else if(type==2){
                    this.endMonth = this.next(this.activeMonth)
                    this.startMonth = this.prev(this.activeMonth)
                }else{
                    this.startMonth = this.activeMonth
                    this.activeMonth = this.next(this.activeMonth)
                    this.endMonth = this.next(this.activeMonth)
                }
                this.loadDateInfo()
            },
            

            next(activeMonth){
                let [year,month] = activeMonth.split('-')
                if(Number(month)==12){
                    year = Number(year)+1
                    month = '01'
                }else{
                    month = Number(month) + 1
                }
                return year + '-' + month
            },

            computedSubStyle(rowIndex,columnIndex,lastItem){
                let json = {
                    cursor:'pointer',
                    position:'relative'
                }
                if(rowIndex>4){
                    json.borderBottom = 'none'
                }
                if((columnIndex+1)%7==0){
                    json.borderRight = 'none'
                }
                if (columnIndex == 5 || columnIndex == 6) {
                    json.color = 'red'
                    
                }
                if(lastItem.isWorkDay){
                    let index = this.shiftIdList.indexOf(lastItem.shiftId)
                    let colorIndex = index%this.colors.length
                    json.background = this.colors[colorIndex]
                    json.color = '#fff'
                }
                return json
            },

            //加载班次列表
            loadShiftConfig() {
                this.$RequestUtil.get({
                    url: '/api/workCalendarShift/listWorkCalendarShift',
                    type: 'sync',
                    params: {},
                    success: (res) => {
                        if (res.code == 0) {
                            this.shiftList = res.data
                        } else {
                            this.$message.error(res.message || res.msg)
                        }
                    }
                });
            },

            addShiftData() {
                this.addDialogVisible = true
                setTimeout(()=>{
                    this.$refs['addShiftForm'].clearValidate()
                },0)
                
            },

            validate(){
                //校验
                // 1. 班次不跨天
                //     1.1开始时间 小于结束时间
                //     1.2 休息时间段 大于等于开始时间 小于结束时间  不能跨天
                //     1.3 休息时间段不能有交集

                // 2.班次跨天
                //     1.1 班次开始时间大于 结束时间
                //     1.2 休息时间跨班次 
                //         1.2.1 休息开始时间大于班次开始时间 结束时间小于班次结束时间   结束时间小于开始时间
                //     1.3 休息时间不跨班次
                //         1.3.1 休息开始时间大于班次开始时间 结束时间必须大于开始时间并且小于24点
                //         1.3.2 开始时间小于班次开始时间  开始时间必须小于结束时间 并且结束时间小于班次结束时间
                //     1.4 如何检测休息时间段是否存在交集？

                let start = this.hoursToMinutes(this.addShiftForm.beginTime)
                let end = this.hoursToMinutes(this.addShiftForm.endTime)
                if(end<start&&!this.addShiftForm.isDaysSpanned){
                    this.$message.error('班次结束时间小于班次开始时间必须选择跨天')
                    return false
                }
                if(end>start&&this.addShiftForm.isDaysSpanned){
                    this.$message.error('班次结束时间大于班次开始时间不能选择跨天')
                    return false
                }
                
                if(this.addShiftForm.isDaysSpanned){
                    end = end + 24*60*60
                    this.addShiftForm.restList.forEach(item=>{
                        item.startNum = this.hoursToMinutes(item.beginTime)
                        item.endNum = this.hoursToMinutes(item.endTime)
                        if(item.startNum>item.endNum){
                            item.endNum = item.endNum + 24*60*60
                        }else{
                            if(item.startNum<item.endNum&&item.startNum<start){
                                item.endNum = item.endNum + 24*60*60
                                item.startNum = item.startNum + 24*60*60
                            }
                        }
                    })
                    
                }else{
                    let find = this.addShiftForm.restList.find(item=>item.isDaysSpanned)
                    if(find){
                        this.$message.error('班次不跨天休息时间不允许跨天')
                        return false
                    }
                    this.addShiftForm.restList.forEach(item=>{
                        item.startNum = this.hoursToMinutes(item.beginTime)
                        item.endNum = this.hoursToMinutes(item.endTime)
                    })
                }
                let list = commonUtils.cloneObj(this.addShiftForm.restList) 
                list.sort((item1,item2)=>item1.startNum-item2.startNum)
                let isPass = this.checkHasConflict(list)
                if(!isPass){
                    return false
                }
                for(let i =0;i<this.addShiftForm.restList.length;i++){
                    let item = this.addShiftForm.restList[i]
                    if(item.startNum<start||item.endNum>end){
                        this.$message.error(`休息时间${item.beginTime}——${item.endTime}时间范围超出班次时间范围`)
                        isPass = false
                    }
                }
                return isPass
            },

            submitAddCalendar(){
                this.$refs['addShiftForm'].validate((valid) => {
                    if (valid) {
                        let isPass =  this.validate()
                        log(isPass,12345)
                        if(!isPass){
                            return
                        }
                        this.$RequestUtil.post({
                            url: '/api/workCalendarShift/addWorkCalendarShift',
                            type: 'sync',
                            params: this.addShiftForm,
                            success: (res) => {
                                if (res.code == 0) {
                                   this.$message.success('新增班次成功')
                                   this.closeAddDialog()
                                   this.loadShiftConfig()
                                } else {
                                    this.$message.error(res.message || res.msg)
                                }
                            }
                        });
                    }
                })
            },

            closeAddDialog(){
                this.addDialogVisible = false
                this.addShiftForm = {
                    beginTime: '',
                    restList:[],
                    endTime: '',
                    shiftCode:'',
                    shiftName:'',
                    isDaysSpanned:false,
                }
            },
            

            async deleteShiftItem(id) {
                let { data, code, msg, message } = await this.$RequestUtil.getAsync({ url: '/api/workCalendarShift/checkWorkCalendarShift', type: 'sync', params: { id }, })
                let str = '是否确认删除当前班次'
                if(data){
                    str = '当前班次被资源使用,是否确认删除当前班次'
                }
                this.$confirm(str, '提示', {
                    cancelButtonClass: "btn-custom-cancel",
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$RequestUtil.post({
                        url: '/api/workCalendarShift/deleteWorkCalendarShift',
                        type: 'sync',
                        params: {id},
                        success: (res) => {
                            if (res.code != -1) {
                                this.$message({
                                    type: 'success',
                                    message: '删除成功!'
                                });
                                this.loadShiftConfig()
                            } else {
                                this.$message.error(res.message || res.msg)
                            }
                        }
                    })
                })
            },

            async loadShiftDetail(id){
                let { data, code, msg, message } = await this.$RequestUtil.getAsync({ url: '/api/workCalendarShift/getWorkCalendarShift', type: 'sync', params: { id }, })
                return data
            },

            async showEditDialog(rowData) {
                let data = await this.loadShiftDetail(rowData.id)
                data.restList.forEach(item=>{
                    if(!item.isDaysSpanned){
                        item.isDaysSpanned = false
                    }
                })
                this.addShiftForm = data
                this.editShiftDialogVisible = true
            },

            submitEditShift(){
                this.$refs['editShiftForm'].validate((valid) => {
                    if (valid) {
                        let isPass =  this.validate()
                        log(isPass,12345)
                        if(!isPass){
                            return
                        }
                        this.$RequestUtil.post({
                            url: '/api/workCalendarShift/updateWorkCalendarShift',
                            type: 'sync',
                            params: this.addShiftForm,
                            success: (res) => {
                                if (res.code == 0) {
                                   this.$message.success('编辑班次成功')
                                   this.closeEditShiftDialog()
                                   this.loadShiftConfig()
                                } else {
                                    this.$message.error(res.message || res.msg)
                                }
                            }
                        });
                    }
                })
            },

            closeEditShiftDialog(){
                this.addShiftForm = {
                    beginTime: '',
                    restList:[],
                    endTime: '',
                    shiftCode:'',
                    shiftName:'',
                    isDaysSpanned:false,
                }
                this.$refs['editShiftForm'].clearValidate()
                this.editShiftDialogVisible = false
            },

            addItem(){
                this.addShiftForm.restList.push({isDaysSpanned:false})
            },

            deleteItem(index){
                this.addShiftForm.restList.splice(index,1)
            },

    
            //将格式化HH:mm时间转化成零点开始的分钟
            hoursToMinutes(timeStr) {
                if(!timeStr){
                    return 0
                }
                let [H, M] = timeStr.split(':')
                return Number(H) * 60 + Number(M)
            },

            dateChange(){
                if(this.addShiftForm.beginTime&&this.addShiftForm.endTime){
                    let start = this.hoursToMinutes(this.addShiftForm.beginTime)
                    let end = this.hoursToMinutes(this.addShiftForm.endTime)
                    let isDaysSpanned = false
                    if(start>end){
                        isDaysSpanned = true
                    }
                    this.$set(this.addShiftForm,'isDaysSpanned',isDaysSpanned)
                }
            },

            submitStartTimeChange(ev,row){
                let start = this.hoursToMinutes(this.addShiftForm.beginTime)
                let subStart = this.hoursToMinutes(ev)
                let subEnd = this.hoursToMinutes(row.endTime)
                if(this.addShiftForm.beginTime){
                    if(subStart<start){
                        this.$set(row,'isDaysSpanned',true)
                    }else{
                        this.$set(row,'isDaysSpanned',false)
                    }
                }
                if(row.endTime){
                    if(subStart>subEnd){
                        this.$set(row,'isDaysSpanned',true)
                    }else{
                        this.$set(row,'isDaysSpanned',false)
                    }
                    
                }
            },

            submitEndTimeChange(ev,row){
                let end = this.hoursToMinutes(this.addShiftForm.endTime)
                let start = this.hoursToMinutes(this.addShiftForm.beginTime)
                let subEnd = this.hoursToMinutes(ev)
                let subStart = this.hoursToMinutes(row.beginTime)
                if(subStart){
                    if(subStart>subEnd){
                        this.$set(row,'isDaysSpanned',true)
                    }else{
                        this.$set(row,'isDaysSpanned',false)
                    }
                }
            },

            //检测默认班次是否存在冲突
            checkHasConflict(list) {
                let hasConflict = true
                for(let i=0;i<list.length;i++){
                    let item = list[i]
                    let next = list[i+1]
                    if(next){
                        if(item.endNum>next.startNum){
                            this.$message.error(`休息时间段${item.beginTime}——${item.endTime}和${next.beginTime}——${next.endTime}存在时间冲突`)
                            log(item,next)
                            hasConflict = false
                            break
                        }
                    }
                }
                return hasConflict
            },
         

            closeEditDialog() {
                this.editDialogVisible = false
                this.addForm = {
                    beginTime: '',
                    endTime: '',
                    isChangeAll:false,
                    isWorkDay: false,
                    shiftId:null,
                    factoryModelId:null,
                    weekDays:[],
                }
            },

            updateCalendar() {
                if (!this.addForm.shiftId&&this.addForm.isWorkDay) {
                    this.$message.warning('班组不能为空请选择班组')
                    return
                }
                this.addForm.factoryModelId = this.selectFactoryModelId
                this.$RequestUtil.post({
                    url: '/api/workCalendarShift/updateResourceCalendar',
                    type: 'sync',
                    params:this.addForm,
                    success: (res) => {
                        if (res.code == 0) {
                            this.$message.success('修改成功')
                            this.loadDateInfo()
                            this.closeEditDialog()
                        } else {
                            this.$message.error(res.message || res.msg)
                        }
                    }
                });
            },

            delDay(item){
                this.$confirm('是否删除当前日历', '提示', {
                    cancelButtonClass: "btn-custom-cancel",
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.addForm.beginTime = item.calDate
                    this.addForm.endTime = item.calDate
                    let weekDay = new Date(item.calDate).getDay()
                    if(weekDay==0){
                        weekDay = 7
                    }
                    this.addForm.weekDays = [weekDay]
                    this.addForm.shiftId = item.shiftId
                    this.addForm.isWorkDay = false
                    this.addForm.factoryModelId = this.selectFactoryModelId
                    this.$RequestUtil.post({
                            url: '/api/workCalendarShift/updateResourceCalendar',
                            type: 'sync',
                            params:this.addForm,
                            success: (res) => {
                                if (res.code == 0) {
                                   this.$message.success('删除成功')
                                   this.loadDateInfo()
                                } else {
                                    this.$message.error(res.message || res.msg)
                                }
                            }
                        });
                })
            },

            itemClick(item,type) {
                
                this.addForm.isChangeAll = false
                this.addForm.isWorkDay = true
                this.addForm.shiftId = null
                if(type==1){ //批量
                    
                    this.addForm.beginTime = this.dataList[0][0].calDate
                    let last = this.dataList[2][this.dataList[2].length-1]
                    this.addForm.endTime = last.calDate
                    this.addForm.isChangeAll = true
                    this.addForm.weekDays = []
                }else{
                    if(!item.calDate){
                        return
                    }
                    this.addForm.beginTime = item.calDate
                    this.addForm.endTime = item.calDate
                    let weekDay = new Date(item.calDate).getDay()
                    if(weekDay==0){
                        weekDay = 7
                    }
                    this.addForm.weekDays = [weekDay]
                    this.addForm.isWorkDay = item.isWorkDay
                    this.addForm.shiftId = item.shiftId
                }
                this.editDialogVisible = true
                this.shiftListCopy = commonUtils.cloneObj(this.shiftList).filter(item=>item.id)
                
            },

   
            parseData() {
                let toDay = commonUtils.timestampToDate(new Date().getTime(),true)
                let shiftIdList = []
                this.dataList.forEach((item, itemIndex) => {
                    let index = item[0].dayOfWeek
                    
                    if (index == 0) {
                        index = 7
                    }
                    let json = { calDate: '' }
                    let number = index - 1
                    let arr = []
                    for (let i = 0; i < number; i++) {
                        arr.push(json)
                    }
                    item = [...arr, ...item]
                    let arr1 = [[], [], [], [], [], []]
                    item.forEach((sub, subIndex) => {
                        if(sub.calDate==toDay){
                            sub.isToDay = true
                        }
                        
                        if(sub.shiftId&&!shiftIdList.includes(sub.shiftId)){
                            shiftIdList.push(sub.shiftId)
                        }
                        let len = Math.floor(subIndex / 7)
                        arr1[len].push(sub)
                    })
                    this.shiftIdList = shiftIdList
                    this.$set(this.copyList, itemIndex, arr1)
                })
            },


            async loadListResource(){
                let {data, code, msg, message} = await this.$RequestUtil.getAsync({url: '/api/select/listResource',type: 'sync', params: {},})
                if (code == 0) {
                    this.listResource =  data
                } else {
                    this.$message.error(msg || message)
                }
            },

            factoryModelChange(){
                this.loadDateInfo()
            },

            loadDateInfo: function () {
                this.$RequestUtil.get({
                    url: '/api/workCalendarShift/getResourceCalendar',
                    type: 'sync',
                    params: {
                        beginTime:this.startMonth,
                        endTime:this.endMonth,
                        factoryModelId:this.selectFactoryModelId,
                    },
                    success: (res) => {
                        if (res.code == 0) {
                            this.dataList = res.data
                            this.parseData()
                        } else {
                            this.$message.error(res.message || res.msg)
                        }
                    }
                });
            }

        },
        filters: {
            parseMonth(item) {
                if (item && item[1] && item[1][0] && item[1][0].calDate) {
                    return item[1][0].calDate.slice(5, 7)
                } else {
                    return ''
                }
            },
            parseDate(lastItem) {
                if (lastItem && lastItem.calDate) {
                    return lastItem.calDate.slice(8)
                } else {
                    return ''
                }
            },
            parseHours(ev){
                if(ev){
                    return (ev/(60*60)).toFixed(1) + 'h'
                }else{
                    return ''
                }
            },
        }
    }
</script>
<style>
    /* #working .working-dialog-wrap{
        overflow-y:auto;
        max-height: 700px;
    } */
    #working .el-radio-button--small .el-radio-button__inner {
        width: 260px;
    }
    .time-range .el-form-item__content {
        width: 400px;
    }

    .table_searchbar .el-button--mini,
    .el-button--mini.is-round {
        padding: 7px 10px;
    }

    .change-time .el-time-spinner .el-time-spinner__wrapper:nth-child(2) {
        display: none !important;
    }

    .change-time {
        width: 220px;
    }
    @media screen and (max-width: 1600px) and (min-width:1280px){
        #working .el-radio-button--small .el-radio-button__inner {
            width: 170px;
        }
        #working .el-card__body {
            padding: 12px 20px;
        }
        #working .el-table tr {
            height: 28px !important;
        }
        #working .el-dialog__footer{
            padding-top: 0px;
            margin-top: -10px;
        }
         #working .month-select .el-input__inner {
            line-height: 30px;
            height: 28px;
        }
        #working .el-date-editor.el-input,#working .el-date-editor.el-input__inner {
            width: 130px !important;
        }
    }
    .month-select .el-input__prefix{
        display: none;
    }
    .month-select .el-input__suffix{
        display: none;
    }
    .month-select .el-input__inner{
        border: none !important;
        text-align: center;
        font-size: 16px;
        cursor: pointer;
    }
</style>
<style scoped>
    /* #working .working-dialog{
        overflow: hidden;
    } */
    .date-picker-warp{
        display: inline-block;
        border: 1px solid #dcdfe5; 
        width:643px;
        display:flex;
        justify-content: space-between;
        border-radius: 4px;
    }
    .head-title{
        font-size: 16px;
        font-family: PingFang SC, PingFang SC-Regular;
        font-weight: 600;
        color: #333333;
    }
    .calendar-warp {
        margin: 0 20px 10px 0;
        flex: 1;
        border: 1px solid #ccc;
        text-align: center;
        box-sizing: border-box;
        border-radius: 10px 10px 0 0;
    }
    .calendar-title {
        text-align: center;
        padding: 10px 0;
        border-bottom: 1px solid #ccc;
        background: #e7f5ff;
        font-family: PingFang SC, PingFang SC-Medium;
        font-weight: 500;
        color: #666666;
        border-radius: 10px 10px 0 0;
    }

    .sub-text {
        /* line-height: 50px; */
        border-right: none;
        border-top: none;
        text-align: center;
        font-size: 12px;
        height: 46px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 100%;
    }
    .left-day{
        width: 100%;
        box-sizing: border-box;
        text-align: left;
        padding-left: 12px;
        font-size: 16px;
        font-family: PingFang SC, PingFang SC-Medium;
    }
    .right-shift{
        width: 100%;
        box-sizing: border-box;
        text-align: right;
        padding-right: 12px;
        font-size: 12px;
        font-family: PingFang SC, PingFang SC-Medium;
    }
    

    .warp-body div,.warp-heard div {
        width: 14.28%;
        justify-content: center;
        /* border: 1px solid #ccc; */
        box-sizing: border-box;
        border-bottom: 1px solid #ccc;
        border-right: 1px solid #ccc;
    }
    .today-bg{
        background-image: url("../../../static/img/day.png");
        background-position-x: 2px;
        background-position-y: bottom;
        background-repeat: no-repeat;
        background-size: 23px;
    }
    .warp-body,.warp-heard {
        /* margin: 0 16px; */
    }

    .scroll {
        max-height: 250px;
        overflow: hidden;
        overflow-y: auto;
        position: relative;
        top: -28px;
        /* scrollbar-width: none; */
    }

    .copy {
        background-color: transparent;
        background: rgb(64, 158, 255);
        border-color: #66b1ff;
        color: #fff;
        padding: 9px 15px;
        font-size: 12px;
        border-radius: 3px;
        display: inline-block;
        line-height: 1;
        white-space: nowrap;
        cursor: pointer;
        border: 1px solid #dcdfe6;
        margin: 0;
        font-weight: 500;
        outline: none;
    }

    .copy:hover {
        outline: none;
    }
    .title {
        color: #606266;
        font-family: NotoSansHans-Regula;
        font-size: 14px;
    }
    .table_searchbar .title11 {
        color: #606266;
        font-family: NotoSansHans-Regula;
        font-size: 14px;
    }

    .el-row {
        margin-bottom: 20px;

        & :last-child {
            margin-bottom: 0;
        }
    }

    .table_searchbar {
        width: 100%;
        margin-top: 10px;
        margin-bottom: 20px;
    }

    .key {
        font-size: 16px;
        color: #c0c4cc;
        font-family: NotoSansHans-Regula;
        padding-right: 10px;
    }

    .value {
        font-size: 16px;
        color: #999;
        font-family: NotoSansHans-Regula;
    }

    .addForm .value {
        display: inline-block;
        max-width: 220px;
    }

    .addForm .title {
        width: 70px;
        text-align: right;
        display: inline-block;
    }
    .time-btn{
        margin: 5px 10px;
        cursor: pointer;
    }

    @media screen and (max-width: 1919px) and (min-width:1440px){
        .warp-body,.warp-heard {
            margin: 0 8px;
        }
        .calendar-warp {
            margin: 0 2.8% 10px auto;
            width: 14%;
        }
        #working .el-radio-button--small .el-radio-button__inner {
            width: 100px;
        }
    }
    @media screen and (max-width: 1439px) and (min-width:1280px){
        .date-picker-warp{
            height: 28px;
        }
        .time-btn{
            margin: 2px 10px;
            cursor: pointer;
        }
        .sub-text {
        
            height: 36px;
        }
        .head-title{
            font-size: 14px;
        }
        .warp-body,.warp-heard {
            margin: 0 0px;
        }
        .calendar-warp {
            margin: 0 2.8% 10px auto;
            width: 14%;
        }
        .calendar-box{
            margin-bottom: 100px;
        }
        #working .el-radio-button--small .el-radio-button__inner {
            width: 100px;
        }
    }
    
   
    .el-icon-circle-close-outline:hover {
        color: red;
    }

    .delete {
        width: 18px;
        height: 19px;
        background-image: url("../../../static/img/del.png");
        cursor: pointer;
        background-repeat: no-repeat;
    }
    .del-day{
        width: 18px;
        height: 19px;
        cursor: pointer;
        display: none;
        position: absolute;
        top: 0;
        right: 0;
    }
    .last-item:hover .del-day{
        display: block;
    }


    .delete:hover {
        background-image: url("../../../static/img/del-hover.png");
        background-repeat: no-repeat;
    }

   
</style>



// WEBPACK FOOTER //
// src/views/Organization/workingCalendar.vue